import React from 'react';
import { TableRow, TableCell } from '@mui/material';
import MaintanceDeptStaticCell from './MaintanceDeptStaticCell';

const MaintanceDeptStateRows = ({ headerRows, data }) => {
  //console.log(JSON.stringify(data));

  if (!headerRows || !data) {
    return null;
  }

  return (
    data &&
    data.map((hq, hqIndex) => {
      return hq?.children.map((dp, dpIndex) => {
        return (
          <TableRow key={dpIndex}>
            {dpIndex === 0 && dp.id !== 'total' && (
              <TableCell rowSpan={hq.rowSpan} sx={{ width: '130px' }}>
                {hq.name}
              </TableCell>
            )}
            <TableCell
              sx={{ width: '110px' }}
              align={dp.id === 'total' ? 'right' : 'left'}
              colSpan={dp.id === 'total' ? 2 : 1}
            >
              {dp.name}
            </TableCell>
            <MaintanceDeptStaticCell headerRows={headerRows} data={dp} />
          </TableRow>
        );
      });
    })
  );
};

export default MaintanceDeptStateRows;
